import MapDataWithSum from "../../../../models/interfaces/dtos/map-data-with-sum-dto";

class MapData {
    center: [number, number];
    
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataSource: any;
    
    constructor(data: MapDataWithSum[]) {
        
        if (data.length === 0) {
            this.center = [2.3, 47]; // La France 🍷🥖🧀
            this.dataSource = [];
            return;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const features: any = [];
        let totalLong = 0;
        let totalLat = 0;
        let totalNon0Elements = 0;

        data.forEach((element) => {
            const { coordinates, sum, name, values } = element;
            if (sum === 0) return;

            totalNon0Elements += 1;
            totalLong += coordinates.longitude;
            totalLat += coordinates.latitude;

            features.push({
                coordinates: [coordinates.longitude, coordinates.latitude],
                name: name,
                sum: sum,
                values: values
            });
        });
        
        if(totalNon0Elements === 0) {
            this.center = [2.3, 47];
        } else {
            this.center = [totalLong / totalNon0Elements, totalLat / totalNon0Elements];
        }        

        this.dataSource = {
            type: 'FeatureCollection',
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            features: features.map((feature: any) => ({
                type: 'Feature',
                geometry: { type: 'Point', coordinates: feature.coordinates },
                properties: {
                    text: feature.name,
                    value: feature.sum,
                    tooltip: `<b>${feature.name}</b>\n${feature.sum}`,
                },
            })),
        };
    }
}

export default MapData;